import { Role } from '@nha/auth/types/role.type';
import { Position } from '.';
import { IEntitlement } from './entitlement.type';

export interface IUser {
	userID: number;
	userGuid: string;
	username: string;
	firstName: string;
	lastName: string;
	fullName: string;
	email: string;
	locationID: number;
	jobTitle: string;
	isServiceCenter: boolean;
	roles: Role[];
	positions: Position[];
	schoolIDs: number[];
	stateIDs: number[];
	staffID: number;

	entitlements: IEntitlement[];
}

export class User implements IUser {
	userID: number;
	userGuid: string;
	username: string;
	firstName: string;
	lastName: string;
	fullName: string;
	email: string;
	locationID: number;
	jobTitle: string;
	isServiceCenter: boolean = false;
	roles: Role[] = [];
	positions: Position[] = [];
	schoolIDs: number[] = [];
	stateIDs: number[] = [];
	staffID: number = -1;

	entitlements: IEntitlement[] = [];
}
